import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, View } from "react-native";

import DoctorAvatar from "./DoctorAvatar";
import DoctorDetail from "./DoctorDetail";

export default class DoctorAvatarWithDetail extends React.Component {
  static propTypes = {
    avatarUrl: PropTypes.string,
    fullName: PropTypes.string.isRequired,
    specialities: PropTypes.string.isRequired
  };

  render() {
    const { avatarUrl, fullName, specialities } = this.props;

    return (
      <View style={styles.container}>
        <DoctorAvatar avatarUrl={avatarUrl} />
        <View style={styles.detailContainer}>
          <DoctorDetail fullName={fullName} specialities={specialities} />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flexDirection: "row"
  },
  detailContainer: {
    marginStart: 10
  }
});
